module.exports = __webpack_public_path__ + "fonts/Klavika-Regular.woff";